<template >
  <base-dialog-form ref="userEditProfileDialog" :title="
    mode === 'EDIT'
      ? ifConfirm
        ? $t('complete_profile')
        : $t('profile')
      : $t('create_profile')
  " :text="surname + ' ' + name" color="secondary" :type="type" icon="mdi-account">
    <template v-slot:actions>
      <v-row v-if="!ifConfirm">
        <v-col v-if="mode === 'EDIT'" md="6" cols="12" class="text-center">
          <v-dialog v-model="passwordDialog" width="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" color="primary">{{
                $t("change_password")
              }}</v-btn>
            </template>

            <v-card>
              <v-card-title>
                {{ $t("change_password") }}
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field v-if="!RBAC_user_RESET_USER_PASSWORD" prepend-icon="mdi-lock-outline"
                        v-model="old_password" :label="$t('old_password')" :rules="required"
                        hide-details="auto"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field prepend-icon="mdi-lock-outline" v-model="new_password" :label="$t('new_password')"
                        :rules="required" hide-details="auto"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field prepend-icon="mdi-lock-outline" v-model="confirm_password"
                        :label="$t('confirm_password')" :rules="required" hide-details="auto"></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="passwordDialog = false" color="primary">{{
                  $t("undo")
                }}</v-btn>
                <v-btn @click="changePassword" color="success">{{
                  $t("confirm")
                }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
        <v-col v-if="mode === 'EDIT'" md="6" cols="12" class="text-center">
          <v-btn @click="updateProfile" color="success">{{
            $t("update_profile")
          }}</v-btn>
        </v-col>
        <v-col v-else cols="12" class="text-center">
          <v-btn @click="updateProfile" color="success">{{
            $t("create_profile")
          }}</v-btn>
        </v-col>
      </v-row>
      <v-row v-if="ifConfirm">
        <v-col cols="12" class="text-center">
          <v-btn @click="updateProfile" :disabled="!enabledConfirmButton" color="success">{{ $t("confirm_profile_data")
          }}</v-btn>
        </v-col>
      </v-row>
    </template>
    <form>
      <v-container>
        <v-row>
          <v-col md="6" cols="12">
            <v-text-field v-model="name" :label="$t('name')" :rules="required" hide-details="auto"></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field v-model="surname" :label="$t('surname')" :rules="required" hide-details="auto"></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field v-if="birthCountry === 'IT'" v-model="cFiscale" :label="$t('fiscal_code')" :rules="required"
              hide-details="auto" :filled="!validCf" :color="!validCf ? 'error' : ''"
              :prepend-icon="validCf ? 'mdi-check-circle' : 'mdi-alert-circle'" append-outer-icon="mdi-calculator"
              @click:append-outer="createCfiscale"></v-text-field>
            <v-text-field v-else v-model="cFiscale" :label="$t('fiscal_code')" hide-details="auto"></v-text-field>
          </v-col>
          <v-col md="3" cols="12">
            <v-radio-group row v-model="sex" :label="$t('sex')">
              <v-radio :label="$t('male')" value="M"></v-radio>
              <v-radio :label="$t('female')" value="F"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col md="3" cols="12">
            <v-radio-group row v-model="ifDisabile" :label="$t('with_disabilities')">
              <v-radio :label="$t('yes')" :value="1"></v-radio>
              <v-radio :label="$t('no')" :value="0"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row>
          <v-col md="4" cols="6">
            <v-autocomplete v-model="birthCountry" :label="$t('birth_country')"
              :rules="birthPlaceRequired ? required : null" :items="isoCode" item-text="Name" item-value="Code"
              hide-details="auto"></v-autocomplete>
          </v-col>
          <v-col md="5" cols="6">
            <v-text-field v-if="!listComuni[birthCountry]" v-model="birthCity" :label="$t('birth_city')"
              :rules="birthPlaceRequired ? required : null" hide-details="auto"></v-text-field>
            <v-combobox v-else v-model="birthCity" :label="$t('birth_city')" :rules="birthPlaceRequired ? required : null"
              :items="listComuni[birthCountry]" item-text="comune" item-value="comune" hide-details="auto"
              :return-object="false" @change="getProvFromBirthCity"></v-combobox>
          </v-col>
          <v-col md="1" cols="6">
            <v-text-field :maxlength="2" v-model="birthProv" :label="$t('province')"
              :rules="birthPlaceRequired ? required : null" hide-details="auto"></v-text-field>
          </v-col>

          <v-col md="2" cols="6">
            <my-datepicker v-model="birthDate" :label="$t('birth_date')" required="true" />
          </v-col>
        </v-row>
        <v-row>
          <v-col md="4" cols="6">
            <v-autocomplete v-model="resCountry" :label="$t('residence_country')"
              :rules="livingRequired ? required : null" :items="isoCode" item-text="Name" item-value="Code"
              hide-details="auto"></v-autocomplete>
          </v-col>
          <v-col md="5" cols="6">
            <v-text-field v-if="!listComuni[resCountry]" v-model="resCity" :label="$t('residence_city')"
              :rules="livingRequired ? required : null" hide-details="auto"></v-text-field>
            <v-autocomplete v-else v-model="resCity" :label="$t('residence_city')"
              :rules="livingRequired ? required : null" :items="listComuni[resCountry]" item-text="comune"
              item-value="comune" hide-details="auto" @change="getProvFromResCity"></v-autocomplete>
          </v-col>
          <v-col md="1" cols="6">
            <v-text-field :disabled="
              listComuni[resCountry] && listComuni[resCountry].length > 0
            " :maxlength="2" v-model="resProv" :label="$t('province')" :rules="livingRequired ? required : null"
              hide-details="auto"></v-text-field>
          </v-col>
          <v-col md="2" cols="6">
            <v-text-field v-model="resCAP" :label="$t('postal_code')" :rules="livingRequired ? requiredNumber : null"
              hide-details="auto"></v-text-field>
          </v-col>
          <v-col md="12" cols="12">
            <v-text-field v-model="resStreet" :label="$t('residence_address')" :rules="livingRequired ? required : null"
              hide-details="auto"></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="minorenne">
          <v-col :md="parent_name_surname_required ? 4 : 6" cols="12">
            <v-text-field v-model="nameRef" :label="$t('parent_name')" :rules="required"
              hide-details="auto"></v-text-field>
          </v-col>
          <v-col :md="parent_name_surname_required ? 4 : 6" cols="12">
            <v-text-field v-model="surnameRef" :label="$t('parent_surname')" :rules="required"
              hide-details="auto"></v-text-field>
          </v-col>
          <v-col v-if="parent_telephone_required" md="4" cols="12">
            <v-text-field v-model="telephoneRef" :label="$t('parent_telephone')" :rules="required"
              hide-details="auto"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" cols="12">
            <v-text-field v-model="email" :label="$t('email_address')" :rules="emailRequired ? requiredEmail : null"
              hide-details="auto"></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field v-model="telephone" :label="$t('telephone')" :rules="user_telephone_required ? required : null"
              hide-details="auto"></v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <v-card v-if="RBAC_user_MODIFY_ADMIN_USER_DATA && !ifConfirm">
        <v-card-title>{{ $t("admin_data") }} </v-card-title>
        <v-container>
          <v-row>
            <v-col md="4" cols="12">
              <v-switch v-model="socioOnorario" :true-value="1" :false-value="0"
                :label="$t('honorary_member')"></v-switch>
            </v-col>
            <v-col md="4" cols="12">
              <v-switch v-model="federazioneStraniera" :label="$t('from_foreign_federation')"></v-switch>
            </v-col>
            <v-col md="4" cols="12">
              <my-datepicker v-if="federazioneStraniera" v-model="dateFirstExtTes" :label="$t('date_affiliation')"
                required="true" />
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </form>
  </base-dialog-form>
</template>
<script>
import Swal from "sweetalert2";
import jwtDecode from "jwt-decode";
import MyDatepicker from "@/components/base/MyDatepicker.vue";

export default {
  name: "user-edit-profile",
  props: {
    paramsIfConfirm: {
      type: Boolean,
      default: false,
    },
    paramsType: {
      type: String,
      default: null,
    },
    paramsMode: {
      type: String,
      default: null,
    },
    paramsMasterId: {
      type: Number,
      default: null,
    },
  },
  components: { MyDatepicker },
  data() {
    return {
      enabledConfirmButton: false,
      RBAC_user_MODIFY_ADMIN_USER_DATA: false,
      RBAC_user_RESET_USER_PASSWORD: false,
      RBAC_ente_ASSIGN_ASD_USER: false,
      RBAC_ente_VIEW_OTHER_ASD: false,
      emailRequired: true,
      livingRequired: true,
      birthPlaceRequired: true,
      user_telephone_required: true,
      parent_telephone_required: true,
      parent_name_surname_required: true,
      type: null,
      federazioneStraniera: null,
      masterId: null,
      mode: null,
      ifConfirm: false,
      name: null,
      surname: null,
      email: null,
      sex: null,
      ifDisabile: null,
      telephone: null,
      cFiscale: null,
      birthCity: null,
      birthDate: null,
      old_password: null,
      new_password: null,
      confirm_password: null,
      birthProv: null,
      socioOnorario: null,
      birthCountry: null,
      resCity: null,
      resStreet: null,
      resCAP: null,
      resCountry: null,
      resProv: null,
      nameRef: null,
      surnameRef: null,
      telephoneRef: null,
      validCf: false,
      dateFirstExtTes: null,
      isoCode: [],
      listComuni: [],
      listAsd: [],
      modal: false,
      passwordDialog: false,
      required: [(value) => !!value || this.$t("required_field")],
      requiredEmail: [
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      ],
      requiredNumber: [
        (value) => (!!value && !isNaN(value)) || this.$t("required_field"),
      ],
      requiredDate: [(value) => !!value || "Required."],
    };
  },
  computed: {
    minorenne: function () {
      return this.eta >= 0 && this.eta < 18;
    },
    eta: function () {
      let eta = -1;
      if (!this.birthDate) return eta;
      let birthday = new Date(this.birthDate);

      if (birthday !== "Invalid Date") {
        var ageDifMs = new Date().getTime() - birthday.getTime();
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        eta = Math.abs(ageDate.getUTCFullYear() - 1970);
      }
      return eta;
    },
  },
  methods: {
    getProvFromBirthCity(city) {
      let selected = this.listComuni[this.birthCountry].filter((comune) => {
        return comune.comune === city;
      });
      if (selected && selected.length === 1)
        this.birthProv = selected[0].provincia;
      else this.birthProv = "";
    },
    getProvFromResCity(city) {
      let selected = this.listComuni[this.resCountry].filter((comune) => {
        return comune.comune === city;
      });
      this.resProv = selected[0].provincia;
    },
    open(mode, masterId) {
      this.type = "dialog";
      this.masterId = masterId;
      this.mode = mode;
      this.ifConfirm = false;
      this.enabledConfirmButton = false;
      this.loadData();
      this.$refs.userEditProfileDialog.open();
    },
    checkCfiscale() {
      let _ = this;
      if (_.birthCountry !== "IT") {
        _.validCf = true;
      } else {
        _.validCf = false;
        if (_.cFiscale && _.cFiscale != "") {
          _.chiamataAxios(
            "GET",
            "/auth/portal/checkCfiscale/" + _.cFiscale
          ).then((response) => {
            _.validCf = response.data.valid;
          });
        }
      }
    },
    createCfiscale() {
      let _ = this;
      let url = "/auth/portal/createCfiscale";
      _.chiamataAxios("POST", url, {
        body: {
          name: _.name,
          surname: _.surname,
          sex: _.sex,
          birthDate: new Date(_.birthDate).toISOString().substr(0, 10),
          birthCity: _.birthCity,
        },
      }).then((response) => {
        if (response.data.cFiscale) {
          _.cFiscale = response.data.cFiscale;
          _.validCf = true;
        }
      });
    }, 
    loadData() {
      let _ = this;
      _.isoCode = window.systemData.isoCode;
      _.parent_telephone_required =
        window.systemData.SYSTEM.parent_telephone_required === "1";
      _.parent_name_surname_required =
        window.systemData.SYSTEM.parent_name_surname_required === "1";
      _.user_telephone_required =
        window.systemData.SYSTEM.user_telephone_required === "1";
      // Carica lista comuni
      _.listComuni = [];
      _.chiamataAxios("GET", "/auth/portal/listComuni/").then((response) => {
        _.listComuni = response.data;
      });

      // Carica lista associazioni
      _.listAsd = [];
      if (_.RBAC_ente_ASSIGN_ASD_USER && _.RBAC_ente_VIEW_OTHER_ASD) {
        _.chiamataAxios("POST", "/auth/ente/listAsd").then((response) => {
          _.listAsd = response.data.filter((asd) => {
            return !asd.myAsd;
          });
          _.listAsd.push({ code: null, ragSoc: _.$t("none_f") });
        });
      }

      _.emailRequired = window.systemData.SYSTEM.user_email_required === "1";
      _.livingRequired = window.systemData.SYSTEM.user_living_required === "1";
      _.birthPlaceRequired =
        window.systemData.SYSTEM.user_birthPlace_required === "1";
      let url = "/auth/portal/getUserData/";
      if (_.masterId) url += _.masterId;
      if (_.mode === "EDIT") {
        // Dati utente
        _.chiamataAxios("GET", url, { dialogLoader: true }).then((response) => {
          _.name = response.data.user.name;
          _.masterId = response.data.user.masterId;
          _.surname = response.data.user.surname;
          _.email = response.data.user.email;
          _.sex = response.data.user.sex;
          _.ifDisabile = response.data.user.ifDisabile;
          _.telephone = response.data.user.telephone;
          _.cFiscale = response.data.user.cFiscale;
          _.birthCity = response.data.user.birthCity;
          _.birthDate = response.data.user.birthDate;
          _.birthProv = response.data.user.birthProv;
          _.birthCountry = response.data.user.birthCountry;
          _.resCity = response.data.user.resCity;
          _.resStreet = response.data.user.resStreet;
          _.resCAP = response.data.user.resCAP;
          _.resCountry = response.data.user.resCountry;
          _.resProv = response.data.user.resProv;
          _.nameRef = response.data.user.nameRef;
          _.surnameRef = response.data.user.surnameRef;
          _.telephoneRef = response.data.user.telephoneRef;
          _.validCf = response.data.user.validCf;
          _.socioOnorario = response.data.user.socioOnorario;
          _.federazioneStraniera = response.data.user.dateFirstExtTes
            ? true
            : false;
          _.dateFirstExtTes = response.data.user.dateFirstExtTes;
          _.enabledConfirmButton = true;
        });
      } else {
        _.sex = "M";
        _.ifDisabile = 0;
        _.name = "";
        _.surname = "";
        _.email = "";
        _.telephone = "";
        _.cFiscale = "";
        _.birthCity = "";
        _.birthDate = "";
        _.birthProv = "";
        _.birthCountry = "";
        _.resCity = "";
        _.resStreet = "";
        _.resCAP = "";
        _.resCountry = "";
        _.resProv = "";
        _.nameRef = "";
        _.surnameRef = "";
        _.telephoneRef = "";
        _.socioOnorario = null;
        _.dateFirstExtTes = null;
        _.validCf = false;
        _.federazioneStraniera = false;
        _.enabledConfirmButton = true;
      }
    },
    changePassword: function () {
      let _ = this;

      let valid = true;
      if (!_.RBAC_user_RESET_USER_PASSWORD) {
        if (!_.old_password || _.old_password === "") valid = false;
      }
      if (!_.new_password || _.new_password === "") valid = false;
      if (!_.confirm_password || _.confirm_password === "") valid = false;
      if (_.new_password !== _.confirm_password) valid = false;
      if (!valid) {
        Swal.fire({
          type: "danger",
          html: "<strong>" + _.$t("invalid_password") + "</strong>",
          confirmButtonClass: "md-button md-success",
        });
      } else {
        _.chiamataAxios("POST", "auth/portal/changePassword/" + _.masterId, {
          body: {
            oldPwd: _.old_password,
            newPwd: _.new_password,
          },
        }).then((response) => {
          Swal.fire({
            type: response.msg.esito ? "success" : "error",
            title: response.msg.esito
              ? _.$t("operation_successfully_completed")
              : _.$t("there_was_an_error"),
            html: response.msg.msgTxt,
          });
          if (response.msg.esito) _.passwordDialog = false;
        });
      }
    },
    updateProfile: function (confirm) {
      let _ = this;
      let url = "/auth/portal/createNewUser/";
      if (_.mode === "EDIT")
        url = "/auth/portal/setUserData/" + (_.masterId ? _.masterId : "");
      _.chiamataAxios("POST", url, {
        body: {
          name: _.name,
          surname: _.surname,
          email: _.email,
          sex: _.sex,
          ifDisabile: _.ifDisabile,
          telephone: _.telephone,
          cFiscale: _.cFiscale,
          birthCity: _.birthCity,
          birthDate: _.birthDate,
          birthProv: _.birthProv,
          birthCountry: _.birthCountry,
          resCity: _.resCity,
          resStreet: _.resStreet,
          resCAP: _.resCAP,
          resCountry: _.resCountry,
          resProv: _.resProv,
          nameRef: _.nameRef,
          surnameRef: _.surnameRef,
          telephoneRef: _.telephoneRef,
          socioOnorario: _.socioOnorario,
          dateFirstExtTes: _.federazioneStraniera ? _.dateFirstExtTes : null,
        },
        dialogLoader: true,
        msg: _.paramsIfConfirm ? "error" : "always",
      }).then((response) => {
        if (response.data) {
          // Aggiorno token solo se sono io
          if (
            !_.masterId &&
            response.data.token &&
            response.data.token !== ""
          ) {
            let decodedToken = jwtDecode(response.data.token);
            window.myData = decodedToken;
            localStorage.setItem("authToken", response.data.token);
            _.$changeAvatar.changeAvatarRsp.updated = new Date().toISOString();
          }
          _.masterId = response.data.masterId;
          _.$emit("isUpdated", "true");
        }
      });
    },
    getClass: function (headerColor) {
      return "md-card-header-" + headerColor + "";
    },
  },
  mounted() {
    this.RBAC_user_MODIFY_ADMIN_USER_DATA = this.checkUserRole(
      "user",
      "MODIFY_ADMIN_USER_DATA"
    );
    this.RBAC_user_RESET_USER_PASSWORD = this.checkUserRole(
      "user",
      "RESET_USER_PASSWORD"
    );
    this.RBAC_ente_ASSIGN_ASD_USER = this.checkUserRole(
      "ente",
      "ASSIGN_ASD_USER"
    );
    this.RBAC_ente_VIEW_OTHER_ASD = this.checkUserRole(
      "ente",
      "VIEW_OTHER_ASD"
    );
    if (this.paramsMasterId || this.paramsType) {
      if (this.paramsType) this.type = this.paramsType;
      else this.type = "plain";
      if (this.paramsIfConfirm) this.ifConfirm = this.paramsIfConfirm;
      else this.ifConfirm = false;
      this.masterId = this.paramsMasterId;
      this.mode = this.paramsMode;
      this.loadData();
    }
  },
  watch: {
    cFiscale: function (newVal, oldVal) {
      this.checkCfiscale();
    },
    paramsMasterId: function (newVal, oldVal) {
      // watch it
      if (newVal !== null) {
        if (this.paramsType) this.type = this.paramsType;
        else this.type = "plain";
        if (this.paramsIfConfirm) this.ifConfirm = this.paramsIfConfirm;
        else this.ifConfirm = false;
        this.masterId = this.paramsMasterId;
        this.mode = this.paramsMode;
        this.loadData();
      }
    },
  },
};
</script>
